/**
 * SSO 必須（FEDERATED_ONLY）組織でパスワードログインが拒否された場合の 403 エラー
 * （code: LOGIN_METHOD_DENIED）。組織切替・リカバリ等の REST 経路で発生する。
 * 再ログイン（SSO）でのみ復旧可能なため、専用エラーとして扱う。
 */
export class LoginMethodDeniedError extends Error {
  constructor(readonly displayMessage?: string) {
    super('Login method denied');
    this.name = 'LoginMethodDeniedError';
    Object.setPrototypeOf(this, LoginMethodDeniedError.prototype);
  }
}